import React from "react"
import { useCurrentSessionStore } from "../../store/useCurrentSessionStore"

export const RED_FLAG_QUESTIONS = [
  { key: "weakness", label: "New weakness, especially one-sided or in a specific muscle group?" },
  { key: "bladderBowel", label: "Changes in bladder or bowel control, or saddle numbness?" },
  { key: "sensation", label: "Numbness, tingling, or loss of sensation — and is it spreading?" },
  { key: "coordination", label: "Trouble walking, balancing, coordinating movement, or using the hands normally?" },
]

export const allRedFlagsAnswered = (redFlagAnswers) =>
  RED_FLAG_QUESTIONS.every((q) => redFlagAnswers[q.key] !== null)

export const anyRedFlagYes = (redFlagAnswers) =>
  RED_FLAG_QUESTIONS.some((q) => redFlagAnswers[q.key] === "yes")

export const allRedFlagsBlank = (redFlagAnswers) =>
  RED_FLAG_QUESTIONS.every((q) => redFlagAnswers[q.key] === null)

const AnswerButtons = ({ value, onAnswer }) => (
  <div style={{ display: "flex", gap: "6px" }}>
    <button
      onClick={() => onAnswer("yes")}
      style={{
        flex: 1, padding: "5px", fontSize: "11px", fontWeight: "600",
        border: `1px solid ${value === "yes" ? "#991B1B" : "var(--phn-border)"}`,
        borderRadius: "4px", cursor: "pointer",
        background: value === "yes" ? "#991B1B" : "#ffffff",
        color: value === "yes" ? "#ffffff" : "var(--phn-text-secondary)",
      }}
    >
      Yes
    </button>
    <button
      onClick={() => onAnswer("no")}
      style={{
        flex: 1, padding: "5px", fontSize: "11px", fontWeight: "600",
        border: `1px solid ${value === "no" ? "#6b7280" : "var(--phn-border)"}`,
        borderRadius: "4px", cursor: "pointer",
        background: value === "no" ? "#6b7280" : "#ffffff",
        color: value === "no" ? "#ffffff" : "var(--phn-text-secondary)",
      }}
    >
      No
    </button>
  </div>
)

export const RedFlagQuestionsList = () => {
  const redFlagAnswers = useCurrentSessionStore((s) => s.redFlagAnswers)
  const setRedFlagAnswer = useCurrentSessionStore((s) => s.setRedFlagAnswer)

  return (
    <div style={{ width: "280px" }}>
      {RED_FLAG_QUESTIONS.map((q) => (
        <div
          key={q.key}
          style={{ background: "var(--phn-bg-subtle)", border: "1px solid var(--phn-border)", borderRadius: "6px", padding: "10px", marginBottom: "8px" }}
        >
          <div style={{ fontSize: "12px", fontWeight: "600", color: "var(--phn-primary-dark)", marginBottom: "8px", lineHeight: "1.4" }}>
            {q.label}
          </div>
          <AnswerButtons value={redFlagAnswers[q.key]} onAnswer={(value) => setRedFlagAnswer(q.key, value)} />
        </div>
      ))}
    </div>
  )
}
